var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home_box flex_all" },
    [
      _vm.baseUrl.indexOf("pre-supplier.shopvidi.com") != -1
        ? _c(
            "div",
            { staticClass: "login_moni", on: { click: _vm.showTempLogin } },
            [_vm._v("模拟登录")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "login_box flex" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login_right" },
          [
            _c("img", {
              staticClass: "shopvidi_logo",
              attrs: { src: require("@/assets/img/shopvidi_logo.png"), alt: "" }
            }),
            _vm._v(" "),
            _c(
              "el-form",
              { ref: "loginForm", attrs: { model: _vm.loginForm } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "email",
                      rules: [
                        {
                          required: true,
                          message: "Please enter the email",
                          trigger: "blur"
                        },
                        {
                          type: "email",
                          message:
                            "Please enter the correct email address or password",
                          trigger: ["blur", "change"]
                        }
                      ]
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "Email" },
                      model: {
                        value: _vm.loginForm.email,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "email", $$v)
                        },
                        expression: "loginForm.email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "password",
                      rules: {
                        required: true,
                        message:
                          "Please enter the correct email address or password",
                        trigger: "blur"
                      }
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: { type: "text", placeholder: "Password" },
                      on: { focus: _vm.changeType },
                      model: {
                        value: _vm.loginForm.password,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "password", $$v)
                        },
                        expression: "loginForm.password"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-checkbox",
                      {
                        staticStyle: { width: "100%", "padding-left": "35px" },
                        model: {
                          value: _vm.loginForm.remember,
                          callback: function($$v) {
                            _vm.$set(_vm.loginForm, "remember", $$v)
                          },
                          expression: "loginForm.remember"
                        }
                      },
                      [_vm._v("Remember")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "forget-btn",
                        on: {
                          click: function($event) {
                            return _vm.$router.push("/forget")
                          }
                        }
                      },
                      [_vm._v("\n            Forgot password?\n          ")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", [
                  _c("p", { staticClass: "text_agreen" }, [
                    _vm._v("By clicking Login, you agree to our "),
                    _c(
                      "a",
                      {
                        attrs: { href: "https://www.shopvidi.com/term-service" }
                      },
                      [
                        _c("span", { staticClass: "organ_color" }, [
                          _vm._v("Terms of Service")
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitForm("loginForm")
                          }
                        }
                      },
                      [_vm._v("Login")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isPartner
                  ? _c("el-form-item", [
                      _c(
                        "div",
                        {
                          staticClass: "brand_register",
                          on: {
                            click: function($event) {
                              return _vm.changeForm("register")
                            }
                          }
                        },
                        [_vm._v("Brand Register")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isPartner
                  ? _c("el-form-item", [
                      _c(
                        "div",
                        {
                          staticClass: "register",
                          on: {
                            click: function($event) {
                              return _vm.changeForm("register")
                            }
                          }
                        },
                        [_vm._v("Register")]
                      )
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "wap",
          attrs: {
            visible: _vm.showTempLoginDialog,
            "destroy-on-close": true,
            width: "880px",
            "append-to-body": true
          },
          on: {
            "update:visible": function($event) {
              _vm.showTempLoginDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { width: "90%", padding: "20px" } },
            [
              _c("el-input", {
                staticStyle: { margin: "30px 0px" },
                attrs: {
                  placeholder: "email",
                  "auto-complete": "new-password"
                },
                model: {
                  value: _vm.email,
                  callback: function($$v) {
                    _vm.email = $$v
                  },
                  expression: "email"
                }
              }),
              _vm._v(" "),
              _c(
                "el-input",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: {
                    placeholder: "password",
                    "auto-complete": "new-password",
                    type: _vm.passw
                  },
                  model: {
                    value: _vm.password,
                    callback: function($$v) {
                      _vm.password = $$v
                    },
                    expression: "password"
                  }
                },
                [
                  _c(
                    "i",
                    {
                      attrs: { slot: "suffix" },
                      on: { click: _vm.showPass },
                      slot: "suffix"
                    },
                    [
                      _vm.passw == "password"
                        ? _c("img", {
                            staticStyle: { width: "25px", height: "25px" },
                            attrs: {
                              src: require("../../assets/img/icon-hide.png"),
                              alt: ""
                            }
                          })
                        : _c("img", {
                            staticStyle: { width: "25px", height: "25px" },
                            attrs: {
                              src: require("../../assets/img/icon-show.png"),
                              alt: ""
                            }
                          })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.tempLogin } }, [
                _vm._v("Login")
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login_left" }, [
      _c("p", { staticClass: "info" }, [
        _c("span", [_vm._v("ShopVidi")]),
        _vm._v(
          " - Global Brands, Local Retailers, One\n        Entrepreneur Dream!\n      "
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "login_img",
        attrs: {
          src:
            "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-login_img.png",
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "icon_line_box" }, [
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line1.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v("Access to numerous retailers across the states")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line2.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v("Guaranteed payments on every order")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line3.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v("Risk-free terms extended to retailers")
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line4.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v(
              "Retailer veriﬁcation, payment collection, & customer support"
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "icon_line flex" }, [
          _c("img", {
            staticClass: "icon_img",
            attrs: {
              src:
                "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-line5.png",
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "text_p2" }, [
            _vm._v("Analytics, and tools to streamline your business")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-250ffb3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-250ffb3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/login.vue
// module id = O85v
// module chunks = 2